import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import CalendarPage from "../components/CalendarPage/CalendarPage";

export default function CalendarPageRoute(): React.JSX.Element {
  const navigate = useNavigate();
  const location = useLocation();
  return <CalendarPage navigate={navigate} location={location} />;
}
